import React from "react";

import CopyClipboard from "js/components/Dashboard/CopyClipboard";
import { ModalInfo } from "js/components/Dashboard/types";
import { Button } from "js/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "js/components/ui/dialog";
import { Separator } from "js/components/ui/separator";

const ShowInfoModal: React.FC<ModalInfo> = ({
  report,
  setIsModalVisible,
  isModalVisible,
}) => {
  const applicantFields = [
    { title: "Solicitante", value: report.person?.name },
    { title: "Correo", value: report.prospectus_email ?? undefined },
    { title: "Teléfono", value: report.person?.phone_number ?? undefined },
    { title: "RFC", value: report.person?.rfc ?? undefined },
    { title: "CURP", value: report.person?.curp ?? undefined },
  ];

  const addressFields = [
    { title: "Domicilio", value: report.person?.address?.address ?? undefined },
    { title: "CP", value: report.person?.address?.zip_code ?? undefined },
    {
      title: "Colonia",
      value: report.person?.address?.neighborhood ?? undefined,
    },
    { title: "Ciudad", value: report.person?.address?.city ?? undefined },
    { title: "Estado", value: report.person?.address?.state ?? undefined },
  ];

  return (
    <Dialog open={isModalVisible} onOpenChange={setIsModalVisible}>
      <DialogContent className="flex w-full max-w-md flex-col overflow-hidden p-0 sm:max-w-lg md:max-w-xl lg:max-w-2xl max-h-[calc(100vh-3rem)]">
        <DialogHeader className="gap-2 px-6 py-4">
          <DialogTitle className="text-2xl font-semibold text-slate-900">
            Información del Reporte
          </DialogTitle>
          <DialogDescription className="text-sm text-slate-500">
            Copia los datos relevantes del solicitante y su domicilio.
          </DialogDescription>
        </DialogHeader>
        <div className="flex-1 overflow-y-auto">
          <div className="space-y-5 px-6 pb-6 pt-4 text-sm text-slate-700">
            <section className="space-y-3">
              <header>
                <p className="text-xs font-semibold uppercase tracking-wide text-slate-600">
                  Datos del solicitante
                </p>
              </header>
              <div className="space-y-2.5">
                {applicantFields.map(({ title, value }) => (
                  <CopyClipboard key={title} title={title} text={value} />
                ))}
              </div>
            </section>
            <Separator />
            <section className="space-y-3 pb-1">
              <header>
                <p className="text-xs font-semibold uppercase tracking-wide text-slate-600">
                  Domicilio
                </p>
              </header>
              <div className="space-y-2.5">
                {addressFields.map(({ title, value }) => (
                  <CopyClipboard key={title} title={title} text={value} />
                ))}
              </div>
            </section>
          </div>
        </div>
        <DialogFooter className="px-6 py-4">
          <Button onClick={() => setIsModalVisible(false)}>
            Cerrar
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ShowInfoModal;
